import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  Divider,
  Avatar,
  Stack
} from "@mui/material";
import { Helmet } from "react-helmet";
import SecurityIcon from "@mui/icons-material/Security";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("privacy.title")}</title>
        <meta name="description" content={t("privacy.intro")} />
        <link rel="alternate" hrefLang="en" href="brainstorm-visions.com/en/privacy-policy" />
        <link rel="alternate" hrefLang="el" href="brainstorm-visions.com/el/privacy-policy" />
      </Helmet>

      <Box
        sx={{
          background: "linear-gradient(135deg, #1e293b 0%, #16202f 100%)",
          color: "#fff",
          pt: { xs: 8, md: 10 },
          pb: { xs: 10, md: 14 },
        }}
      >
        <Container maxWidth="md">
          <Card
            sx={{
              p: { xs: 3, md: 5 },
              borderRadius: 4,
              boxShadow: 6,
              backgroundColor: "#fff",
              color: "#1e293b",
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center" mb={3}>
              <Avatar
                sx={{
                  bgcolor: "#57a1d8",
                  width: 60,
                  height: 60,
                }}
              >
                <SecurityIcon sx={{ fontSize: 32, color: "#fff" }} />
              </Avatar>
              <Box>
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  gutterBottom
                  sx={{ color: "#1e293b" }}
                >
                  {t("privacy.title")}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {t("privacy.intro")}
                </Typography>
              </Box>
            </Stack>

            <Section title={t("privacy.dataCollectionTitle")} content={t("privacy.dataCollection")} />
            <Divider sx={{ my: 3 }} />
            <Section title={t("privacy.cookiesTitle")} content={t("privacy.cookies")} />
            <Divider sx={{ my: 3 }} />
            <Section title={t("privacy.contactTitle")} content={t("privacy.contact")} isHtml />
          </Card>
        </Container>
      </Box>
    </>
  );
};

const Section = ({ title, content, isHtml = false }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="h6" fontWeight="bold" gutterBottom color="primary">
      {title}
    </Typography>
    {isHtml ? (
      <Typography
        variant="body1"
        sx={{ lineHeight: 1.8 }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    ) : (
      <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
        {content}
      </Typography>
    )}
  </Box>
);

export default PrivacyPolicy;
